export default __webpack_public_path__ + "media/images/field-0ee197313b80f4e34a7e162a3b7d6f34.jpg";